export default "__VITE_ASSET__0ADpzvwt__"